import { Component } from '@theme/component';
import { RecentSearches } from '@theme/recent-searches';

/**
 * Renders the shopper's recent searches as a list of links.
 *
 * @typedef {object} Refs
 * @property {HTMLUListElement} list - The list element to populate.
 * @extends {Component<Refs>}
 */
class RecentSearchesList extends Component {
  requiredRefs = ['list'];

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  render() {
    const max = Number(this.dataset.maxItems) || 5;
    const terms = RecentSearches.getTerms().slice(0, max);
    const searchUrl = Theme.routes.search_url;

    this.refs.list.replaceChildren(
      ...terms.map((term) => {
        const item = document.createElement('li');
        const link = document.createElement('a');

        link.className = 'search-drawer__term-link';
        // type=product so the term lands on the Product Results tab with an exact count, rather
        // than on an unscoped search that search-tabs.js has to redirect.
        link.href = `${searchUrl}?q=${encodeURIComponent(term)}&type=product`;
        // textContent, never innerHTML — terms are shopper input and must not be parsed as markup.
        link.textContent = term;
        item.appendChild(link);

        return item;
      })
    );
  }

  /**
   * Clears every stored term and re-renders, which empties the list and hides the block.
   * @param {MouseEvent} event - The click event.
   */
  clearTerms(event) {
    event.stopPropagation();
    RecentSearches.clearTerms();
    this.render();
  }
}

if (!customElements.get('recent-searches-list')) {
  customElements.define('recent-searches-list', RecentSearchesList);
}
